const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const
const EASE_OUT_BACK_SOFT = [0.22, 1, 0.36, 1] as const

const IN_VIEW = { once: true, amount: 0.3 } as const

const HERO_MOTION = {
  section: { y: 24, duration: 0.7 },
  kpi: { y: 12, duration: 0.5, delay: 0.3, stagger: 0.09 },
  countUp: { durationMs: 1400 },
  gaugeArc: { duration: 1.6 },
  askMeAnything: { y: 20, duration: 0.6, delay: 0.2 },
  overlay: { duration: 0.2 },
  insightRow: { y: 16, duration: 0.5, stagger: 0.08 },
  teaserCard: { y: 12, duration: 0.45, stagger: 0.08 },
  contentSwap: { duration: 0.2 },
  dialog: { y: 12, scale: 0.96, duration: 0.25, ease: EASE_OUT_EXPO },
  metricDialog: { y: 12, scale: 0.97, duration: 0.18, ease: 'easeOut' },
  loops: {
    dashDrift: { offset: -56, duration: 3.2 },
    glow: { opacity: [0.35, 0.7, 0.35], duration: 3.5 },
    startDot: { scale: [1, 1.35, 1], duration: 2.2 },
    readyChip: { scale: [1, 1.025, 1], duration: 2.8 },
  },
} as const

export { EASE_OUT_EXPO, EASE_OUT_BACK_SOFT, IN_VIEW, HERO_MOTION }
